import {
  getCsvHeaderUrl,
  getCubeUrl,
  getFileMappingUrl,
} from "../../../constants/urls";
import {
  allRequest,
  getRequest,
  REQUEST_METHOD_GET,
} from "../../../middlewares/api/actions";

export const EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ =
  "EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ";
export const EL_MAPPING_RESET_MAPPING = "EL_MAPPING_RESET_MAPPING";
export const EL_MAPPING_FILE_MAPPING_READ = "EL_MAPPING_FILE_MAPPING_READ";
export const EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT =
  "EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT";
export const EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT =
  "EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT";
export const EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD =
  "EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD";
export const EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL =
  "EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL";
export const EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE =
  "EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE";
export const EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL =
  "EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL";
export const EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT =
  "EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT";

export const getELCsvMappingsCube = (
  csvSeparator,
  csvDelimiter,
  csvHasHeader,
  csvServerPath,
  cubeId
) => {

  return {
  ...allRequest(
    EL_MAPPING_CSV_HEADER_MAPPINGS_CUBE_READ,
    [REQUEST_METHOD_GET, REQUEST_METHOD_GET, REQUEST_METHOD_GET],
    [
      getCsvHeaderUrl(csvSeparator, csvDelimiter, csvHasHeader, csvServerPath),
      getFileMappingUrl(),
      getCubeUrl(cubeId),
    ]
  ),
  cubeId
  };
};


export const resetELMapping = () => ({
  type: EL_MAPPING_RESET_MAPPING,
});

export const readELFileMapping = fileMappingId =>
  getRequest(EL_MAPPING_FILE_MAPPING_READ, getFileMappingUrl(fileMappingId));

export const selectELMappingColumn = columnName => ({
  type: EL_MAPPING_FILE_COMPONENT_COLUMN_SELECT,
  columnName,
});

export const addELComponentMapperComponent = (
  columnName,
  cubeComponentCode
) => ({
  type: EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD,
  columnName,
  cubeComponentCode,
});

export const removeELComponentMapperComponent = (
  columnName,
  cubeComponentCode
) => ({
  type: EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE,
  columnName,
  cubeComponentCode,
});

export const removeAllELComponentMapperComponent = () => ({
  type: EL_MAPPING_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL,
});

export const addAllELComponentMapperComponent = () => ({
  type: EL_MAPPING_COMPONENT_MAPPER_COMPONENT_ADD_ALL,
});

export const selectELComponentMapperComponent = (
  columnName,
  cubeComponentCode
) => ({
  type: EL_MAPPING_COMPONENT_MAPPER_COMPONENT_SELECT,
  columnName,
  cubeComponentCode,
});

export const selectELCubeComponentListComponent = cubeComponentCode => ({
  type: EL_MAPPING_CUBE_COMPONENT_LIST_COMPONENT_SELECT,
  cubeComponentCode,
});



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/actions.js